import type { MRT_ColumnDef } from "@ngt/mantine-react-table";
import DataGridTruncateCell from "./DataGridTruncateCell";

const DataGridStringCell: MRT_ColumnDef<any>["Cell"] = ({ cell }) => {
    const value = cell.getValue<string>();

    if (!value) {
        return null;
    }

    return <DataGridTruncateCell tooltip={value} value={value} />;
};
export default DataGridStringCell;
